import {
	EuiButton,
	EuiTitle,
	EuiFlexGroup,
	EuiFlexItem,
	EuiSpacer,
} from '@equipmentshare/ds2'

import Box from '@mui/material/Box'

import DataGrid from 'views/components/DataGrid'

import {
	getAddPermissionsModal,
	getRemovePermissionModal,
} from '../actionModals'

import { useDispatchSetSelectedModal } from 'contexts/modal-context/modal-context'
import { PermissionMeta, Role } from 'graphql'
import { TABLE_HEIGHT } from 'views/helpers/utils'

import getColumns from './columns'
import { heapEvent } from '@equipmentshare/heaper'

export type PermissionsTableProps = {
	selectedRole: Role,
}

export default function PermissionsTable( { selectedRole }: PermissionsTableProps ) {
	const setSelectedModal = useDispatchSetSelectedModal()
	const onAddClick = () => {
		heapEvent( 'Inventory - Permission Roles - Click - Add Permission', {} )
		setSelectedModal( getAddPermissionsModal( selectedRole ) )
	}
	const onRemoveClick = ( permission: PermissionMeta ) => {
		heapEvent( 'Inventory - Permission Roles - Click - Remove Permission', {} )
		setSelectedModal( getRemovePermissionModal( selectedRole, permission ) )
	}
	const columns = getColumns( onRemoveClick )
	const rows = selectedRole.permissions.filter( ( p ): p is PermissionMeta => p !== null )

	return (
		<>
			<EuiFlexGroup alignItems="center" gutterSize="xl" style={{ flexGrow: 0 }}>
				<EuiFlexItem grow={false}>
					<EuiTitle size="s"><h2>Permissions</h2></EuiTitle>
				</EuiFlexItem>
				<EuiFlexItem grow={false}>
					<EuiButton
						iconType="plus"
						onClick={onAddClick}
						size="s"
						color="text"
					>
						Add permission
					</EuiButton>
				</EuiFlexItem>
			</EuiFlexGroup>
			<EuiSpacer size="m" />
			<Box sx={{ height: TABLE_HEIGHT }}>
				<DataGrid
					columns={columns}
					rows={rows}
					isLoading={false}
					emptyStateText="No permissions"
					autoHeight={false}
				/>
			</Box>
		</>
	)
}
